<template>
  <el-dialog
    v-focus
    class="modal-header"
    :title="$t('modalTimeout.title')"
    :visible.sync="openedModal"
    width="50%"
    :before-close="cancelModal"
    tabindex="0"
    @keyup.esc="cancelModal"
  >
    <span class="modal-title">{{ $t('modalTimeout.message') }}</span>
    <span slot="footer" class="dialog-footer">
      <el-button type="danger" @click="cancelModal">{{ $t('modalTimeout.btnCancel') }}</el-button>
      <el-button type="primary" @click="confirmModal">{{ $t('modalTimeout.btnConfirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<style lang="scss" scoped>
.modal-header {
  font-weight: bold;
}

.modal-title {
  font-size: 18px;
  font-weight: initial;
}
</style>

<script>
import { mapActions } from 'vuex';

export default {
  props: {
    timeout: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      openedModal: false,
      modalTimer: null,
    };
  },
  watch: {
    timeout() {
      if (this.timeout == true) {
        this.openedModal = true;

        this.modalTimer = setTimeout(() => {
          if (this.openedModal === true) {
            this.openedModal = false;
            this.onLogout();
          }
        }, 10000);
      }
    },
  },
  methods: {
    ...mapActions({
      logout: 'auth/AUTH_LOGOUT',
    }),
    onLogout() {
      this.logout().then(() => {
        location.reload();
      });
    },
    cancelModal() {
      this.openedModal = false;
      clearTimeout(this.modalTimer);
    },
    confirmModal() {
      this.openedModal = false;
      clearTimeout(this.modalTimer);
      this.onLogout();
    },
  },
};
</script>
